import { ChoicesCartItem } from "@lib/hooks/helpers/types"

type ExistingCustomCombinationCartItems = {
  items: ChoicesCartItem[]
  customCombinationId: string
}

export function getExistingCustomCombinationCartItemIds({
  items,
  customCombinationId,
}: ExistingCustomCombinationCartItems): string[] {
  let components: string[] = []

  if (!customCombinationId || !items || items.length === 0) {
    return []
  }

  for (const item of items) {
    if (item.message && item.message.includes(customCombinationId)) {
      components.push(item.id)
    }
  }

  return components
}
